module.exports = require("./kab.d.ts");